import * as actions from './actions'

const adminStore = {
  namespaced: true,
  actions,
}

export default adminStore